import { action, makeObservable, observable } from 'mobx';
import { canvasTranslationKeys as canvasTranslationKeysEnum } from '../enums';

class GameStore {
  matrix = [];

  noWinMatrix = [];

  lastSpinMatrix = [];

  gameTypeId = 86;

  bonusType = null;

  jackpotAmountVisible = false;

  isIntroMode = false;

  freeBetInfo = {};

  tournamentInfo = {};

  tournamentInfoInitial = {};

  gameSymbolsSpineData = {};

  canvasTranslationKeys = {};

  reelSpeed = 0;

  oddsInfo = [];

  isOpenBigWinPopup = false;

  isGameBackSideOpacity = false;

  fps = 60;

  deltaFrame = 1;

  collectValidationType = null;

  hasGamble = false;

  constructor() {
    makeObservable(this, {
      fps: observable,
      hasGamble: observable,
      bonusType: observable,
      reelSpeed: observable,
      deltaFrame: observable,
      isIntroMode: observable,
      jackpotAmountVisible: observable,
      matrix: observable.deep,
      isGameBackSideOpacity: observable,
      gameTypeId: observable.deep,
      freeBetInfo: observable.deep,
      tournamentInfo: observable.deep,
      tournamentInfoInitial: observable.deep,
      isOpenBigWinPopup: observable,
      gameSymbolsSpineData: observable.deep,
      oddsInfo: observable.deep,
      noWinMatrix: observable.deep,
      lastSpinMatrix: observable.deep,
      canvasTranslationKeys: observable.deep,
      collectValidationType: observable,
      setReelSpeed: action.bound,
      setBonusType: action.bound,
      setFreeBetInfo: action.bound,
      setTournamentInfo: action.bound,
      setInitialTournamentInfo: action.bound,
      toggleIntroMode: action.bound,
      setOddsInfo: action.bound,
      setIsOpenBigWinPopup: action.bound,
      setFps: action.bound,
      setDeltaFrame: action.bound,
      setNoWinMatrix: action.bound,
      setLastSpinMatrix: action.bound,
      setIsGameBackSideOpacity: action.bound,
      setGameResultMatrix: action.bound,
      setGameSymbolsSpineData: action.bound,
      setTranslationsTextInCanvas: action.bound,
      setCollectValidationType: action.bound,
      setHasGamble: action.bound,
    });
  }

  setHasGamble(bool) {
    this.hasGamble = bool;
  }

  setDeltaFrame(deltaFrame) {
    this.deltaFrame = deltaFrame;
  }

  setFps(fps) {
    this.fps = fps;
  }

  setIsGameBackSideOpacity(bool) {
    this.isGameBackSideOpacity = bool;
  }

  setIsOpenBigWinPopup(bool) {
    this.isOpenBigWinPopup = bool;
  }

  setOddsInfo(oddsInfo) {
    this.oddsInfo = oddsInfo;
  }

  setNoWinMatrix(matrix) {
    this.noWinMatrix = matrix;
  }

  setLastSpinMatrix(matrix) {
    this.lastSpinMatrix = matrix;
  }

  setJackpotAmountVisible(boolValue) {
    this.jackpotAmountVisible = boolValue;
  }

  setBonusType(type) {
    this.bonusType = type;
  }

  setFreeBetInfo(obj) {
    this.freeBetInfo = obj;
  }

  setTournamentInfo(obj) {
    this.tournamentInfo = obj;
  }

  setInitialTournamentInfo(obj) {
    this.tournamentInfoInitial = obj;
  }

  setReelSpeed(value) {
    this.reelSpeed = value;
  }

  setGameResultMatrix(resultMatrix) {
    this.matrix = resultMatrix;
  }

  setGameSymbolsSpineData(symbolId, symbol) {
    this.gameSymbolsSpineData[symbolId] = symbol;
  }

  setTranslationsTextInCanvas(translations) {
    this.canvasTranslationKeys = Object.keys(canvasTranslationKeysEnum).reduce((acc, current) => {
      if (translations[current]) {
        acc[current] = translations[current];
      }
      return acc;
    }, {});
  }

  toggleIntroMode(boolValue) {
    this.isIntroMode = boolValue;
  }

  setCollectValidationType(typeId) {
    this.collectValidationType = typeId;
  }
  resetStore() {
    this.matrix = [];

    this.noWinMatrix = [];

    this.lastSpinMatrix = [];

    this.freeBetInfo = {};

    this.tournamentInfo = {};
  }
}

export const gameStore = new GameStore();
